module.exports = __webpack_public_path__ + "static/img/v3.993ea497.jpg";